import { createReducer } from '@reduxjs/toolkit';

import updateListingCompatibilityList, {
  clearUpdateListingCompatibilityList
} from '../../thunks/Compatibility/updateListingCompatibilityList';

const initialState = {
  loading: false,
  error: '',
  data: null,
};

const updateListingCompatibilityListReducer = createReducer(initialState, {
  [updateListingCompatibilityList.pending]: (state) => ({
    ...state,
    loading: true,
    error: null
  }),
  [updateListingCompatibilityList.fulfilled]: (state, { payload: data }) => ({
    ...state,
    loading: false,
    data,
  }),
  [updateListingCompatibilityList.rejected]: (state, { payload }) => ({
    ...state,
    loading: false,
    error: payload,
    data: null
  }),
  [clearUpdateListingCompatibilityList]: () => initialState,
});

export default updateListingCompatibilityListReducer;
